import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavBtn } from './navbtn';
import { NavbtnService } from './navbtn.service';
@Component({
  selector: 'app-navbtn',
  templateUrl: './navbtn.component.html',
  styleUrls: ['./navbtn.component.css']
})
export class NavbtnComponent implements OnInit {
 navbts: NavBtn[] = [];
        subscription: Subscription;
  constructor(private nb:NavbtnService) { }

  ngOnInit(): void {
      
        this.subscription = this.nb.onAdd().subscribe(btns => {
      this.navbts=[];
      if(btns.btn){ this.navbts.push(btns);}
        
      
  
  })
  }
   removeBtn(navbtn: NavBtn) {
      
        this.navbts = this.navbts.filter(x => x !== navbtn);
    }

}
